import { College } from './college.model';
import { StatutJure } from './statut-jure.model';
import { Defaut } from './defaut.model';
import { TypeLeurre } from './type-leurre.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class References {
    static jsonMap = {
        colleges: { key: 'colleges', converter: new (ArrayClassConverterFactory.build(College))(), default: () => [] },
        statutsJure: { key: 'statutsJure', converter: new (ArrayClassConverterFactory.build(StatutJure))(), default: () => [] },
        defauts: { key: 'defauts', converter: new (ArrayClassConverterFactory.build(Defaut))(), default: () => [] },
        typesLeurres: { key: 'typesLeurres', converter: new (ArrayClassConverterFactory.build(TypeLeurre))(), default: () => [] }
    };

    colleges: College[];
    statutsJure: StatutJure[];
    defauts: Defaut[];
    typesLeurres: TypeLeurre[];
}
